/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aifeaturecoverimage3Inputs */

const en_aifeaturecoverimage3 = /** @type {(inputs: Aifeaturecoverimage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Image generation`)
};

const de_aifeaturecoverimage3 = /** @type {(inputs: Aifeaturecoverimage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bild erstellen`)
};

/**
* | output |
* | --- |
* | "Image generation" |
*
* @param {Aifeaturecoverimage3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aifeaturecoverimage3 = /** @type {((inputs?: Aifeaturecoverimage3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aifeaturecoverimage3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aifeaturecoverimage3(inputs)
	return de_aifeaturecoverimage3(inputs)
});
export { aifeaturecoverimage3 as "aiFeatureCoverImage" }